import { MinusSquareOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { IssueCaseStatusCode } from '@gooduncles/gu-app-schema';
import { Button, Select, Space } from 'antd';
import { isAfter, isBefore } from 'date-fns';
import dayjs from 'dayjs';
import { FC, useRef } from 'react';

import { issueCaseStatusBadgeMap } from 'src/utils/issue/issue-util';

import { useIssueManageData } from '../../../hooks/subscription/useIssueManageData';

import DatePickerWithArrows from 'src/components/Common/DatePickerWithArrows/DatePickerWithArrows';

import IssueManageTable, { IssueManageTableHandle } from './IssueManageTable';

const IssueManage: FC = () => {
  const tableRef = useRef<IssueManageTableHandle>(null);
  const {
    selectedDate,
    handleDateChange,
    selectedStatuses,
    setSelectedStatuses,
    rowData,
    isLoading,
    minDate,
    maxDate,
  } = useIssueManageData();

  const dateForPicker = selectedDate ? dayjs(selectedDate) : null;

  const handleDayjsChange = (newDate: dayjs.Dayjs | null) => {
    handleDateChange(newDate ? newDate.toDate() : null);
  };

  const setDateWrapper = (value: dayjs.Dayjs | null | ((prev: dayjs.Dayjs | null) => dayjs.Dayjs | null)) => {
    let newDayjs: dayjs.Dayjs | null = null;
    if (typeof value === 'function') {
      newDayjs = value(dateForPicker);
    } else {
      newDayjs = value;
    }
    handleDayjsChange(newDayjs);
  };

  const disabledDate = (current: dayjs.Dayjs) => {
    const date = current.toDate();
    return isBefore(date, minDate) || isAfter(date, maxDate);
  };

  const statusOptions = [
    IssueCaseStatusCode.PENDING,
    IssueCaseStatusCode.OPEN,
    IssueCaseStatusCode.IN_PROGRESS,
    IssueCaseStatusCode.CLOSED,
    IssueCaseStatusCode.CANCELED,
  ].map((status) => ({
    label: issueCaseStatusBadgeMap[status].text,
    value: status,
  }));

  return (
    <div className='height100 flexColumn' style={{ gap: '16px' }}>
      <div className='flexRow flexAlignCenter flexSpaceBetween'>
        <div className='flexRow flexAlignCenter' style={{ gap: 16 }}>
          <div className='flexRow flexAlignCenter' style={{ gap: 8 }}>
            <span>조회 시작일:</span>
            <DatePickerWithArrows date={dateForPicker} setDate={setDateWrapper} disabledDate={disabledDate} />
          </div>
          <div className='flexRow' style={{ alignItems: 'center', gap: '8px' }}>
            <span>상태:</span>
            <Select
              mode='multiple'
              placeholder='상태 선택'
              style={{ minWidth: 300 }}
              value={selectedStatuses}
              onChange={setSelectedStatuses}
              options={statusOptions}
            />
          </div>
        </div>
        <Space>
          <Button icon={<PlusSquareOutlined />} onClick={() => tableRef.current?.expandAll()}>
            모두 펼치기
          </Button>
          <Button icon={<MinusSquareOutlined />} onClick={() => tableRef.current?.collapseAll()}>
            모두 접기
          </Button>
        </Space>
      </div>

      <div style={{ flex: 1, minHeight: 0 }}>
        <IssueManageTable ref={tableRef} rowData={rowData} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default IssueManage;
